import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// axios
import { axios } from '../../../../constants/axiosConfig';

import { Icon, message } from "antd";

// styles
import {
  Dragger,
  ImportButton
} from "./styles";

// icons
import {
  SendOutlined
} from '@ant-design/icons';

import { getCompanies } from "../../../actions";
import { getResults } from "../../Result/actions";
import { getProducts as getPisCofins } from "../../Classify/PisCofins/actions";
import { getProducts as getIcms } from "../../Classify/Icms/actions";

import { split, toLower } from "lodash";

function Upload({ setVerHistorico }) {
  const dispatch = useDispatch();
  // const upload = useSelector((state) => state.upload);
  const importacao = useSelector((state) => state.importacao);

  const [fileList, setFileList] = useState([]);

  const [buttonLoad, setbuttonLoad] = useState(false);

  // objeto de estado movido do redux
  const [enviar, setEnviar] = useState({});
  const [isFetching, setIsFetching] = useState(false);

  const atualizarHistorico = useCallback(() => {
    const { Mensagem, StatusCode } = enviar;

    if (StatusCode) {
      if (StatusCode === 200) {
        setFileList([]);
        setVerHistorico(true);
        message.success(Mensagem);
        setbuttonLoad(false);
      } else {
        message.error(Mensagem);
      }
    }
  }, [enviar])

  useEffect(() => {
    atualizarHistorico();

    if (!importacao.processando) {
      dispatch(getResults());
      dispatch(getIcms(`?pageNumber=1&pageSize=50`));
      dispatch(getPisCofins(`?pageNumber=1&pageSize=50`));
      dispatch(getCompanies());
    }
  }, [importacao.processando, atualizarHistorico]);

  const enviarArquivo = () => {
    const formData = new FormData();
    fileList.forEach((file) => formData.append("file", file));
    formData.append(
      "Cnpj",
      JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj
    );
    formData.append("ImportarSomenteValidos", true);

    setbuttonLoad(true);
    setIsFetching(true);

    axios.post("envioArquivos/v2/obrigacoes", formData)
      .then((res) => {
        setEnviar(res.data);
        setIsFetching(false);
      })
      .catch((err) => {
        setIsFetching(false);
      });
  };

  const propsUpload = {
    onRemove: (file) => {
      const newFileList = [...fileList];
      const index = newFileList.indexOf(file);
      newFileList.splice(index, 1);
      setFileList([...newFileList]);
      if (!newFileList.length) {
        setVerHistorico(true);
      }
    },
    beforeUpload: (file, fileList) => {
      let tamanhoValido = verificaTamanhoArquivo(file);
      let validado = verificaExtensao(file.name);
      if (fileList.length <= 20 && validado && tamanhoValido) {
        setFileList((prev) => [...prev, file]);
        setVerHistorico(false);
      }
      return false;
    },
    multiple: true,
    disabled: isFetching,
    accept: '.xml,.txt,.pdf,.xls,.xlsx,.zip,.rar',
    fileList,
  };

  return (
    <>
      <Dragger
        fullScreen={false}
        {...propsUpload}>
        <p className="ant-upload-drag-icon">
          <Icon type="inbox" />
        </p>
        <p className="ant-upload-text">
          Clique ou arraste o(s) arquivo(s) para esta área.
        </p>
        <p className="ant-upload-hint">
          Tipos de arquivos permitidos: XML, TXT, PDF, XLSX, ZIP ou RAR.
        </p>
        <p className="ant-upload-hint ">
          Acima de 20 arquivos, crie um arquivo .zip ou .rar para uma melhor
          experiência
        </p>
      </Dragger>

      {!!fileList.length && (
        <ImportButton
          loading={buttonLoad}
          className="mt-3 float-right"
          type="primary"
          onClick={enviarArquivo}

        >
          Enviar
          <SendOutlined />
        </ImportButton>
      )}
    </>
  );
}

function verificaExtensao(nomeArquivo) {
  const extPermitidas = ['xml', 'txt', 'pdf', 'xls', 'xlsx', 'zip', 'rar'];
  nomeArquivo = toLower(nomeArquivo);
  const extArquivo = split(nomeArquivo, '.').pop();
  if (typeof extPermitidas.find(function (ext) { return extArquivo === ext; }) == 'undefined') {
    message.warning('Extensão "' + extArquivo + '" não permitida!');
    return false;
  } else {
    //message.success('Arquivo importado com sucesso!');
    return true;
  }
}

function verificaTamanhoArquivo(file) {
  if(file.size === 0){
    message.warning('O arquivo "' + file.name + '" está vazio!');
    return false;
  }
  return true;
}

export default Upload;
